import storage from 'shared/helpers/storage';

const SESSION_KEY = 'PDP_RECENTLY_VIEWED';
const MAX_RECENTLY_VIEWED_WIDGETS = 15;

export const getRecentViewedPDP = () => {
  let data = [];
  try {
    data = JSON.parse(storage.getItem<string>(SESSION_KEY, '') || '');
  } catch (err) {
    //do nothing
  }
  return data;
};

export const setRecentViewedPDP = (data: ProductDetail.IProduct[]) => {
  storage.setItem(SESSION_KEY, JSON.stringify(data.splice(0, MAX_RECENTLY_VIEWED_WIDGETS)));
};

export const removeRecentViewedPDP = (productID: string) => {
  const data = getRecentViewedPDP().filter((item) => item.id !== productID);
  setRecentViewedPDP(data);
};

export const addRecentViewedPDP = (data: ProductDetail.IProduct) => {
  const existingData = getRecentViewedPDP().filter((item) => item.id !== data.id);

  const { id, sku, title, subTitle, action_url, imageUrl } = data;

  setRecentViewedPDP([{ id, sku, title, subTitle, action_url, imageUrl }, ...existingData]);
};
